module.exports = "<div class=\"wrapper content-layout-background\">\n    <div class=\"content-wrapper\">\n        <div class=\"container-fluid\">\n            <router-outlet></router-outlet>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/content/content-layout.component.html
// module id = ./src/app/layouts/content/content-layout.component.html
// module chunks = main